import React, { createContext, useContext } from 'react';
import { UserDetails } from '@fiverr-private/homepage_common_types';

const UserContext = createContext<UserDetails | undefined>(undefined);

type UserProviderProps = UserDetails & { children: React.ReactNode };

export function UserProvider({ children, ...user }: UserProviderProps) {
    return <UserContext.Provider value={user}>{children}</UserContext.Provider>;
}

export const useUser = (): UserDetails => {
    const user = useContext(UserContext);

    if (!user) {
        throw new Error('useUser must be used within a UserProvider');
    }

    return user;
};
